import React from "react";
import ModalWrap from "../modals/ModalWrap";
import VideoPlayer from "./VideoPlayer";
import "./modalVideoPlayer.scss";
import closeIcon from "../../assets/images/closeIcon.svg";

const ModalVideoPlayer = ({
  videoShow,
  videoPlayerCloseHandler,
  src,
  landscape,
}) => {
  return (
    <ModalWrap
      open={videoShow}
      onClose={() => videoPlayerCloseHandler()}
      className="video-modal-wrapper"
    >
      <div
        className={`videoplayer-content-wrapper ${landscape && "custom-landscape"}`}
      >
        <div className="video-close-icon-wrapper">
          <img
            src={closeIcon}
            className="close-icon"
            onClick={() => videoPlayerCloseHandler()}
          />
        </div>
        <VideoPlayer src={src} />
      </div>
    </ModalWrap>
  );
};

export default ModalVideoPlayer;
